import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Packages
import { Button, Col, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import OrgFilters from '../../filters/OrgFilters';
import ErrorModal from './ErrorModal';
import ErrorsTable from './ErrorsTable';

// Actions
import { get_all_self_errors } from '../../../redux/actions/selfErrorsActions';

const Errors = (props) => {
	const { messageApi } = props;

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const [orgFilters, setOrgFilters] = useState({ organization: '' });
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [update, setUpdate] = useState(false);
	const [errorToUpdate, setErrorToUpdate] = useState({});
	const [pageSize] = useState(10);
	const [skip, setSkip] = useState(0);

	useEffect(() => {
		if (orgFilters.organization !== '') {
			const filters = { ...orgFilters, skip: 0, limit: 10 };
			dispatch(get_all_self_errors(filters));
		}
	}, [orgFilters]);

	const createError = () => {
		setIsModalOpen(true);
		setUpdate(false);
		setErrorToUpdate({});
	}

	return (
		<Row justify='center'>
			<Col lg={17} md={17} sm={24} xs={24}>
				<ErrorModal
					messageApi={messageApi}
					isModalOpen={isModalOpen}
					setIsModalOpen={setIsModalOpen}
					orgFilters={orgFilters}
					update={update}
					errorToUpdate={errorToUpdate}
					pageSize={pageSize}
					skip={skip}
				/>

				<Row justify='center'>
					<Col lg={8} md={8} sm={24} xs={24}></Col>
					<Col lg={8} md={8} sm={24} xs={24}>
						<Typography.Title className='text-center' level={2}>{t('errors.title')}</Typography.Title>
					</Col>
					<Col style={{ textAlign: 'end' }} lg={8} md={8} sm={24} xs={24}>
						<Button
							type='primary'
							size='large'
							onClick={() => createError()}
						>
							{t('loadForm.create.title').split(' ')[0]}
						</Button>
					</Col>
				</Row>

				<OrgFilters
					orgFilters={orgFilters}
					setOrgFilters={setOrgFilters}
					displayFilters={{ organization: true, workspace: false, module: false }}
				/>

				<ErrorsTable
					messageApi={messageApi}
					orgFilters={orgFilters}
					setIsModalOpen={setIsModalOpen}
					setUpdate={setUpdate}
					setErrorToUpdate={setErrorToUpdate}
					pageSize={pageSize}
					skip={skip}
					setSkip={setSkip}
				/>
			</Col>
		</Row>
	);
}

Errors.propTypes = {
	messageApi: PropTypes.object.isRequired
}

export default Errors;
